import styled from 'styled-components';

import type { MemberPrices, StandardPrices } from '@front/customer/src/types/prices';
import { getFormattedPrice, getFormattedPromotion } from '@front/customer/src/utils/cleaning';

import { translate } from '@front/i18n';

import Separator from '@front/web-ui/src/components/separator/separator';

import { calculationLineStyle } from '../../../../common/common';
import Reduction from '../common/reduction';

const t = translate('basket');

const ReductionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  padding: 10px 0;
`;

const PromotionLine = styled(Reduction)`
  ${calculationLineStyle}
  padding: 0;
`;

type SingleReductionsProps = {
  hasDuration: boolean;
  prices?: StandardPrices | MemberPrices;
};

const SingleReductions = ({ hasDuration, prices }: SingleReductionsProps) => {
  const hasPromo = !!prices?.promotion;
  // If the prices has a discount value, it means that the user has the membership
  const shouldShowMembershipReduction = !!prices && 'discount' in prices && prices.discount.price > 0;
  const hasAnyReduction = shouldShowMembershipReduction || hasPromo;

  return (
    <>
      {hasAnyReduction && (
        <>
          <Separator />
          <ReductionsWrapper>
            {shouldShowMembershipReduction && (
              <Reduction
                title={t('.membership.reductions')}
                reduction={getFormattedPrice(hasDuration, prices.discount)}
                label={t('.membership.label_full')}
              />
            )}
            {hasPromo && (
              <PromotionLine
                title={t('.promo_code')}
                reduction={getFormattedPromotion(hasDuration, prices?.promotion)}
              />
            )}
          </ReductionsWrapper>
        </>
      )}
    </>
  );
};

export default SingleReductions;
